/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EntityCategoryEnum } from '../models';
// @ts-ignore
import type { EntitySettingRowModel } from '../models';
// @ts-ignore
import type { EntitySettingsModel } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * EntitySettingsApi - axios parameter creator
 * @export
 */
export const EntitySettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get entity settings
         * @param {EntityCategoryEnum} entityCategory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntitySettings: async (entityCategory: EntityCategoryEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityCategory' is not null or undefined
            assertParamExists('getEntitySettings', 'entityCategory', entityCategory)
            const localVarPath = `/api/v1/entitysetting/{entityCategory}`
                .replace(`{${"entityCategory"}}`, encodeURIComponent(String(entityCategory)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary patch settings
         * @param {EntityCategoryEnum} entityCategory 
         * @param {Array<EntitySettingRowModel>} entitySettingRowModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntitySettings: async (entityCategory: EntityCategoryEnum, entitySettingRowModel: Array<EntitySettingRowModel>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityCategory' is not null or undefined
            assertParamExists('patchEntitySettings', 'entityCategory', entityCategory)
            // verify required parameter 'entitySettingRowModel' is not null or undefined
            assertParamExists('patchEntitySettings', 'entitySettingRowModel', entitySettingRowModel)
            const localVarPath = `/api/v1/entitysetting/{entityCategory}`
                .replace(`{${"entityCategory"}}`, encodeURIComponent(String(entityCategory)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entitySettingRowModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntitySettingsApi - functional programming interface
 * @export
 */
export const EntitySettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntitySettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get entity settings
         * @param {EntityCategoryEnum} entityCategory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntitySettings(entityCategory: EntityCategoryEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntitySettingsModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntitySettings(entityCategory, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntitySettingsApi.getEntitySettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary patch settings
         * @param {EntityCategoryEnum} entityCategory 
         * @param {Array<EntitySettingRowModel>} entitySettingRowModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntitySettings(entityCategory: EntityCategoryEnum, entitySettingRowModel: Array<EntitySettingRowModel>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntitySettings(entityCategory, entitySettingRowModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntitySettingsApi.patchEntitySettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntitySettingsApi - factory interface
 * @export
 */
export const EntitySettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntitySettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary get entity settings
         * @param {EntitySettingsApiGetEntitySettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntitySettings(requestParameters: EntitySettingsApiGetEntitySettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntitySettingsModel> {
            return localVarFp.getEntitySettings(requestParameters.entityCategory, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary patch settings
         * @param {EntitySettingsApiPatchEntitySettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntitySettings(requestParameters: EntitySettingsApiPatchEntitySettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchEntitySettings(requestParameters.entityCategory, requestParameters.entitySettingRowModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntitySettingsApi - interface
 * @export
 * @interface EntitySettingsApi
 */
export interface EntitySettingsApiInterface {
    /**
     * 
     * @summary get entity settings
     * @param {EntitySettingsApiGetEntitySettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitySettingsApiInterface
     */
    getEntitySettings(requestParameters: EntitySettingsApiGetEntitySettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntitySettingsModel>;

    /**
     * 
     * @summary patch settings
     * @param {EntitySettingsApiPatchEntitySettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitySettingsApiInterface
     */
    patchEntitySettings(requestParameters: EntitySettingsApiPatchEntitySettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getEntitySettings operation in EntitySettingsApi.
 * @export
 * @interface EntitySettingsApiGetEntitySettingsRequest
 */
export interface EntitySettingsApiGetEntitySettingsRequest {
    /**
     * 
     * @type {EntityCategoryEnum}
     * @memberof EntitySettingsApiGetEntitySettings
     */
    readonly entityCategory: EntityCategoryEnum
}

/**
 * Request parameters for patchEntitySettings operation in EntitySettingsApi.
 * @export
 * @interface EntitySettingsApiPatchEntitySettingsRequest
 */
export interface EntitySettingsApiPatchEntitySettingsRequest {
    /**
     * 
     * @type {EntityCategoryEnum}
     * @memberof EntitySettingsApiPatchEntitySettings
     */
    readonly entityCategory: EntityCategoryEnum

    /**
     * 
     * @type {Array<EntitySettingRowModel>}
     * @memberof EntitySettingsApiPatchEntitySettings
     */
    readonly entitySettingRowModel: Array<EntitySettingRowModel>
}

/**
 * EntitySettingsApi - object-oriented interface
 * @export
 * @class EntitySettingsApi
 * @extends {BaseAPI}
 */
export class EntitySettingsApi extends BaseAPI implements EntitySettingsApiInterface {
    /**
     * 
     * @summary get entity settings
     * @param {EntitySettingsApiGetEntitySettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitySettingsApi
     */
    public getEntitySettings(requestParameters: EntitySettingsApiGetEntitySettingsRequest, options?: RawAxiosRequestConfig) {
        return EntitySettingsApiFp(this.configuration).getEntitySettings(requestParameters.entityCategory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary patch settings
     * @param {EntitySettingsApiPatchEntitySettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitySettingsApi
     */
    public patchEntitySettings(requestParameters: EntitySettingsApiPatchEntitySettingsRequest, options?: RawAxiosRequestConfig) {
        return EntitySettingsApiFp(this.configuration).patchEntitySettings(requestParameters.entityCategory, requestParameters.entitySettingRowModel, options).then((request) => request(this.axios, this.basePath));
    }
}

